import React, { useState, useEffect } from 'react'
import { collection, addDoc, query, orderBy, onSnapshot, serverTimestamp } from 'firebase/firestore'
import { db } from '../../firebaseConfig'
import * as XLSX from 'xlsx'

export default function PengeluaranPage({ orders, expenses }) { // 👈 Terima prop dari Parent
  const [showModal, setShowModal] = useState(false)
  const [formData, setFormData] = useState({ type: 'Ads', amount: '', note: '' })

  // 1. Hitung Total Pemasukan
  const totalIncome = orders.reduce((acc, curr) => acc + (curr.commissionDeducted || 0), 0)
  
  // 2. Hitung Total Pengeluaran
  const totalExpenses = expenses.reduce((acc, curr) => acc + (curr.amount || 0), 0)
  const netBalance = totalIncome - totalExpenses

  // 👈 FUNGSI UTAMA EXPORT EXCEL YANG RAPI
  const handleExportExcel = () => {
    if (expenses.length === 0) return alert('Tidak ada data pengeluaran untuk diekspor.')

    // Mapping kolom agar terpisah dan rapi di Excel
    const dataToExport = expenses.map((exp, index) => {
      let tanggalFormated = '-'
      let waktuFormated = '-'
      
      if (exp.createdAt) {
        const dateObj = exp.createdAt.toDate()
        tanggalFormated = dateObj.toLocaleDateString('id-ID')
        waktuFormated = dateObj.toLocaleTimeString('id-ID')
      }

      return {
        'No': index + 1,
        'Tanggal Catat': tanggalFormated,
        'Waktu': waktuFormated,
        'Kategori Beban': exp.type,
        'Keterangan / Catatan': exp.note || '-',
        'Nominal Pengeluaran (Rp)': exp.amount,
        'Pencatat': exp.recordedBy || 'System'
      }
    })

    const worksheet = XLSX.utils.json_to_sheet(dataToExport)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Beban Operasional")

    // Unduh file dengan nama yang jelas
    XLSX.writeFile(workbook, "Laporan_Beban_Operasional_Zimo.xlsx")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    await addDoc(collection(db, 'company_expenses'), {
      ...formData,
      amount: Number(formData.amount),
      createdAt: serverTimestamp(),
      recordedBy: 'Admin'
    })
    setShowModal(false)
    setFormData({ type: 'Ads', amount: '', note: '' })
  }

  return (
    <div className="p-6">
      {/* 👈 KARTU RINGKASAN KEUANGAN BARU */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="bg-green-900/30 border border-green-700 p-4 rounded-lg">
          <p className="text-gray-400 text-sm">Total Pendapatan (Komisi)</p>
          <p className="text-2xl font-bold text-green-400">Rp {totalIncome.toLocaleString('id-ID')}</p>
        </div>
        <div className="bg-red-900/30 border border-red-700 p-4 rounded-lg">
          <p className="text-gray-400 text-sm">Total Beban/Pengeluaran</p>
          <p className="text-2xl font-bold text-red-400">Rp {totalExpenses.toLocaleString('id-ID')}</p>
        </div>
        <div className="bg-blue-900/30 border border-blue-700 p-4 rounded-lg">
          <p className="text-gray-400 text-sm">Saldo Bersih (Net Profit)</p>
          <p className={`text-2xl font-bold ${netBalance >= 0 ? 'text-blue-400' : 'text-orange-500'}`}>
            Rp {netBalance.toLocaleString('id-ID')}
          </p>
        </div>
      </div>

      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-white">📉 Riwayat Pengeluaran</h2>
        <div className="flex gap-2">
          {/* 👈 BUTTON EXPORT EXCEL HIJAU */}
          <button 
            onClick={handleExportExcel} 
            className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg text-white font-bold transition shadow-lg flex items-center gap-2"
          >
            📊 Export Excel
          </button>
          <button 
            onClick={() => setShowModal(true)} 
            className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded-lg text-white font-bold transition shadow-lg"
          >
            + Catat Pengeluaran
          </button>
        </div>
      </div>

      <div className="bg-gray-800 rounded-lg overflow-hidden border border-gray-700">
        <table className="w-full text-left text-sm text-gray-300">
          <thead className="bg-gray-700 text-gray-400 uppercase">
            <tr>
              <th className="px-6 py-3">Kategori</th>
              <th className="px-6 py-3">Catatan</th>
              <th className="px-6 py-3 text-right">Nominal</th>
            </tr>
          </thead>
          <tbody>
            {expenses.map(exp => (
              <tr key={exp.id} className="border-t border-gray-700">
                <td className="px-6 py-3 font-bold">{exp.type}</td>
                <td className="px-6 py-3">{exp.note}</td>
                <td className="px-6 py-3 text-right text-red-400 font-bold">- Rp {exp.amount.toLocaleString('id-ID')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal Input Manual */}
      {showModal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-50">
          <form onSubmit={handleSubmit} className="bg-gray-900 p-6 rounded-xl w-full max-w-sm border border-gray-700">
            <h3 className="text-lg font-bold mb-4">Catat Pengeluaran Baru</h3>
            <select className="w-full bg-gray-800 p-2 rounded mb-3" onChange={e => setFormData({...formData, type: e.target.value})}>
              <option value="Ads">Biaya Iklan (Ads)</option>
              <option value="Server">Biaya Server</option>
              <option value="Domain">Domain & Hosting</option>
              <option value="Lainnya">Lainnya</option>
            </select>
            <input type="number" placeholder="Nominal (Rp)" className="w-full bg-gray-800 p-2 rounded mb-3" onChange={e => setFormData({...formData, amount: e.target.value})} />
            <input type="text" placeholder="Catatan" className="w-full bg-gray-800 p-2 rounded mb-3" onChange={e => setFormData({...formData, note: e.target.value})} />
            <div className="flex gap-2">
              <button type="button" onClick={() => setShowModal(false)} className="flex-1 p-2 bg-gray-700 rounded">Batal</button>
              <button type="submit" className="flex-1 p-2 bg-red-600 rounded text-white font-bold">Simpan</button>
            </div>
          </form>
        </div>
      )}
    </div>
  )
}